import * as React from 'react'
import {Provider} from 'react-redux'

import ContactSupportModal, {
  Props,
} from './ContactSupportModal/ContactSupportModal'
import store from './store'

const ContactSupport: React.FC<Props> = (props) => {
  return (
    <Provider store={store}>
      <ContactSupportModal {...props} />
    </Provider>
  )
}

export default ContactSupport
